// import Divider from 'tio-reimagined/components/divider';
import { Section, VStack } from 'tio-reimagined/components/layout';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import FeedContainer from './feed/feed-container.gts';
import CurrencySuperscriptCents from '../currency-superscript-cents.gts';
import ItemPayment from './feed/item-payment.gts';
import type { PaymentEvent } from '../../types/tuition-assistance.ts';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';

interface PaymentDetailsCardComponentSignature {
  Args: {
    showDetails: boolean;
    requestedTotal: number;
    payments?: PaymentEvent[];
    netPaidAmount?: number;
    /** Whether this is a credits-based program */
    isCreditBased?: boolean;
    /** Total credits requested (for credits-based programs) */
    totalCredits?: number;
  };
}

class PaymentDetailsCard extends Component<PaymentDetailsCardComponentSignature> {
  @service declare intl: IntlService;

  get filteredPayments() {
    if (!this.args.payments) return [];

    return this.args.payments.filter((payment) => {
      const isCourseCash = payment.assistanceType.startsWith('CARD_');

      if (isCourseCash) {
        return (
          payment.assistanceType === 'CARD_AUTHORIZED' || payment.assistanceType === 'CARD_CAPTURED'
        );
      }

      return true;
    });
  }

  /**
   * Format credits for display (e.g. "12 credits")
   */
  formatCredits = (count?: number) => {
    if (count) {
      return this.intl.t('tas.dashboard.annual_benefits.credits_count', { count });
    } else {
      return this.intl.t('tas.dashboard.annual_benefits.credits_count', { count: 0 });
    }
  };

  <template>
    {{#if @showDetails}}
      <VStack>
        <Section>
          <:header>{{t "tas.history.payment_details"}}</:header>
          <:body>
            {{#if this.filteredPayments}}
              <FeedContainer @feed={{this.filteredPayments}}>
                <:record as |item|>
                  <ItemPayment
                    @amount={{item.amount}}
                    @date={{item.date}}
                    @paymentType={{item.assistanceType}}
                  />
                </:record>
              </FeedContainer>
            {{/if}}
            {{!-- <Divider class="my-2" />
           <div>
            <span class="text-violet-500 font-semibold">
              <CurrencySuperscriptCents @amountCents={{@netPaidAmount}} />
              {{#if (gte @netPaidAmount 0)}}
                Amount Paid
              {{else}}
                Outstanding Balance
              {{/if}}
            </span>
          </div> --}}
          </:body>
        </Section>
      </VStack>
    {{else}}
      <VStack>
        <Section>
          <:header>
            {{t "tuition_assistance.limits_summary.requested_amount"}}
          </:header>
          <:body>
            <div class="text-lg text-violet-500 font-semibold">
              <CurrencySuperscriptCents @amountCents={{@requestedTotal}} />
            </div>
          </:body>
        </Section>
      </VStack>
    {{/if}}
  </template>
}

export default PaymentDetailsCard;
